import React from 'react'
import classNames from 'classnames'

import styles from './index.module.scss'

export default class Layout extends React.PureComponent {
  render () {
    const { title, titleTips, left, text, button, modalType } = this.props
    return (
      <div className={styles.layout}>
        <div className={classNames(styles.layoutTitle, 'font-portrait')}>{title}</div>
        <div className={styles.layoutTitleTips}>{titleTips}</div>
        <div className={styles.layoutContent}>
          <div>{left}</div>
          <div>
            <div className={styles.layoutText}>{text}</div>
            {'logo-trans'!==modalType && <div className={styles.layoutBtn}>{button}</div>}
          </div>
        </div>
      </div>
    )
  }
}
